module.exports = __webpack_public_path__ + "img/img3.4b0bee2a.jpg";